import { withInstall } from '@ideaz/utils'
import Radio from './src/index'

export default withInstall(Radio)
export * from './src/props'
